'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionQuestionAnswer = function ActionQuestionAnswer(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z' })
  );
};
ActionQuestionAnswer = (0, _pure2.default)(ActionQuestionAnswer);
ActionQuestionAnswer.displayName = 'ActionQuestionAnswer';
ActionQuestionAnswer.muiName = 'SvgIcon';

exports.default = ActionQuestionAnswer;


//////////////////
// WEBPACK FOOTER
// /~/material-ui/svg-icons/action/question-answer.js
// module id = HwUN
// module chunks = 0